import React from "react";
import { Text, View } from "react-native";
import { useTranslation } from "react-i18next";
import ScButton from "@/src/components/ui-kit/button";

/** Never substitute the All feed while a requested Following scope is unavailable. */
export function FollowingScopeContent({
  scope,
  available,
  following,
  all,
  onShowAll,
}: {
  scope: string;
  available: boolean;
  following: React.ReactNode;
  all: React.ReactNode;
  onShowAll: () => void;
}) {
  const { t } = useTranslation();
  if (scope !== "following") return <>{all}</>;
  if (available) return <>{following}</>;
  return (
    <View className="gap-4 p-4">
      <Text accessibilityLiveRegion="polite" className="text-slate">
        {t("FOLLOW_UNAVAILABLE")}
      </Text>
      <ScButton
        text="LABEL_ALL"
        mode="outlined"
        style={{ minHeight: 44 }}
        onPress={onShowAll}
      />
    </View>
  );
}
